module.exports = "/_next/static/images/BuildHighPerformance-1-8e3df2ceb12f3366a8f804566c3c1c5f.webp";